
import { useEffect, useState } from "react";
import { useParams } from "react-router";

import style from './AdminInfo.module.css'
import formattedDateTime from "../../../../utils/formatDatewithTime";
import AdminNavBar from "../../NavBar/AdminNavBar";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

export default function AdminInfo() {

    const [employee, setEmployee] = useState([])
    const [payrolls, setPayrolls] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('')
    const { employeeId } = useParams();

    const apiurl = process.env.REACT_APP_SERVER_URL
    const token = localStorage.getItem("token");

    // fetch the employee Full Info
    const GetEmployee = () => {
        return (
            fetch(`${apiurl}/employee-dashboard/${employeeId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            })
                .then((res) => res.json())
                .then((d) => {
                    setLoading(false)
                    setEmployee(d.user);
                }
                )
                .catch((err) => {
                    setError(err);
                    setLoading(true)
                })
        )
    }

    // fetch payroll by id
    const fetchPayrollById = () => {
        return (
            fetch(`${apiurl}/payroll/${employeeId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            })
                .then((res) => res.json())
                .then((data) => setPayrolls(data.payroll))
                .catch((err) => setError(err.message))
        )
    }

    useEffect(() => {
        GetEmployee();
        fetchPayrollById()
    }, [apiurl, token])

    return (
        <>
            <div className="container">
                <AdminNavBar />

                {/* BreadCrumb Linkss */}
                <div className="col-8 col-lg-5 mb-3 ">
                    <BreadCrumb
                        link={`/admin-dashboard/${employeeId}`}
                        name="Dashboard"
                        icon={true}
                    />
                    <BreadCrumb
                        link={`/admin-dashboard/${employeeId}/all-users`}
                        name="All user"
                        icon={true}
                    />
                    <BreadCrumb
                        link={`/admin-dashboard/${employeeId}/info`}
                        name="Your Info"
                    />
                </div>

                {/* error component  */}
                {error && <p className="text-danger">{error.message}</p>}
                <table className="table table-hover table-striped table-responsive">
                    {
                        loading ?
                            <>
                                <tbody>
                                    {Array.from({ length: 18 }).map((_, idx) => {
                                        return (
                                            <>
                                                <tr key={idx} >
                                                    <td className=" text-center">
                                                        <span className="w-25 placeholder placeholder-xs"></span>
                                                    </td>
                                                    <td className=" text-center">
                                                        <span className="w-25 placeholder placeholder-xs"></span>
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })}
                                </tbody>
                            </>
                            :
                            <>
                                <table className="table table-hover table-striped table-responsive">
                                    <thead>
                                        <tr>
                                            <th className="ps-4">Title</th>
                                            <th className="ps-4">Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className={`${style.text} ps-4 w-50`}>Name</td>
                                            <td className={`${style.text} ps-4 w-50`}>
                                                {employee ? employee.firstName : "Pending"} {employee ? employee.lastName : ""}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Employee ID</td>
                                            <td className={`${style.text} ps-4`}>
                                                {employee?.employeeId
                                                    ?
                                                    employee.employeeId
                                                    :
                                                    <td className=" text-center w-25 placeholder placeholder-xs">
                                                    </td>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Email</td>
                                            <td className={`${style.text} ps-4`}>
                                                {employee?.email ? employee.email : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Phone</td>
                                            <td className={`${style.text} ps-4`}>
                                                {employee?.phonePrimary ? employee.phonePrimary : "Pending"},
                                                {employee?.phoneSecondary ? employee.phoneSecondary : ""}
                                            </td>
                                        </tr>

                                        {employee?.socialLinks?.linkedIn && (
                                            <tr>
                                                <td className={`${style.text} ps-4`}>LinkedIn</td>
                                                <td className={`${style.text} ps-4`}>
                                                    <a href={employee.socialLinks.linkedIn} target="_blank" rel="noreferrer">
                                                        {employee.socialLinks.linkedIn}
                                                    </a>
                                                </td>
                                            </tr>
                                        )}

                                        {employee?.socialLinks?.github && (
                                            <tr>
                                                <td className={`${style.text} ps-4`}>Github</td>
                                                <td className={`${style.text} ps-4`}>
                                                    <a href={employee.socialLinks.github} target="_blank" rel="noreferrer">
                                                        {employee.socialLinks.github}
                                                    </a>
                                                </td>
                                            </tr>
                                        )}

                                        {employee?.socialLinks?.x && (
                                            <tr>
                                                <td className={`${style.text} ps-4`}>X</td>
                                                <td className={`${style.text} ps-4`}>
                                                    <a href={employee.socialLinks.x} target="_blank" rel="noreferrer">
                                                        {employee.socialLinks.x}
                                                    </a>
                                                </td>
                                            </tr>
                                        )}

                                        <tr>
                                            <td className={`${style.text} ps-4`}>Age</td>
                                            <td className={`${style.text} ps-4`}>
                                                {employee?.age ? employee.age : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Role</td>
                                            <td className={`${style.text} ps-4`}>
                                                {employee?.role ? employee.role : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Gender</td>
                                            <td className={`${style.text} ps-4`}>
                                                {employee?.gender ? employee.gender : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Position</td>
                                            <td className={`${style.text} ps-4`}>
                                                {employee?.position ? employee.position : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Team Name</td>
                                            <td className={`${style.text} ps-4`}>
                                                {employee?.teamName ? employee.teamName : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Address</td>
                                            <td className={`${style.text} ps-4`}>
                                                {employee?.address ? employee.address : "Pending"}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <p className="text-center ">Payroll Details</p>

                                <table className="table table-striped table-hover">
                                    <tbody>
                                        <tr>
                                            <td className={`${style.text} ps-4 w-50 `}>Base Salary</td>
                                            <td className={`${style.text} ps-4 w-50`}>
                                                {payrolls?.baseSalary
                                                    ? Number(payrolls.baseSalary).toLocaleString('en-IN')
                                                    : "Pending"}

                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Bonus</td>
                                            <td className={`${style.text} ps-4`}>
                                                {payrolls?.bonus
                                                    ? Number(payrolls.bonus).toLocaleString('en-IN')
                                                    : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Allowances</td>
                                            <td className={`${style.text} ps-4`}>
                                                {payrolls?.allowances
                                                    ? Number(payrolls.allowances).toLocaleString('en-IN')
                                                    : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Deductions</td>
                                            <td className={`${style.text} ps-4`}>
                                                {payrolls?.deductions
                                                    ? Number(payrolls.deductions).toLocaleString('en-IN')
                                                    : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Gross Salary</td>
                                            <td className={`${style.text} ps-4`}>
                                                {payrolls?.grossSalary
                                                    ? Number(payrolls.grossSalary).toLocaleString('en-IN')
                                                    : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Net Salary</td>
                                            <td className={`${style.text} ps-4`}>
                                                {payrolls?.netSalary
                                                    ? Number(payrolls.netSalary).toLocaleString('en-IN')
                                                    : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Created By</td>
                                            <td className={`${style.text} ps-4`}>
                                                {payrolls?.createdBy
                                                    ? typeof payrolls.createdBy === "object"
                                                        ? payrolls.createdBy.employeeId || "Unknown"
                                                        : payrolls.createdBy
                                                    : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Created At</td>
                                            <td className={`${style.text} ps-4`}>
                                                {payrolls?.createdAt
                                                    ? formattedDateTime(payrolls.createdAt)
                                                    : "Pending"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={`${style.text} ps-4`}>Last Update</td>
                                            <td className={`${style.text} ps-4`}>
                                                {payrolls?.updatedAt
                                                    ? formattedDateTime(payrolls.updatedAt)
                                                    : "Pending"}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </>
                    }
                </table>
            </div>
        </>
    )
}